import type { ModelConfig, Slicer } from '../store';

export interface DocumentVisibilityState {
  isDocumentVisible: boolean;
}

const effects = {};
interface DocumentVisibilityModel extends ModelConfig<DocumentVisibilityState> {
  reducers: typeof reducers;
  effects: typeof effects;
  selectors: typeof selectors;
}

const reducers = {
  setDocumentVisibility: (
    state: DocumentVisibilityState,
    isDocumentVisible: boolean
  ): DocumentVisibilityState => ({
    ...state,
    isDocumentVisible
  })
};

const selectors = (slice: Slicer<DocumentVisibilityState>) => ({
  isDocumentVisible: () => slice((state) => state.isDocumentVisible)
});

const documentVisibility: DocumentVisibilityModel = {
  state: {
    isDocumentVisible: true
  },
  selectors,
  effects,
  reducers
};

export default documentVisibility;
